// @ts-ignore
import * as dynamic from './dynamic/i18n.zh-Hans';
import { ITranslations } from './types';

const i18n: ITranslations = {};
i18n['agencies'] = {};
i18n['agencies']['budget-asc-order'] = "";
i18n['agencies']['budget-desc-order'] = "";
i18n['agencies']['budget-from'] = "";
i18n['agencies']['budget-to'] = "";
i18n['agencies']['budgets'] = "";
i18n['agencies']['certificates'] = "服务";
i18n['agencies']['cities'] = "城市";
i18n['agencies']['city'] = "城市";
i18n['agencies']['countries'] = "国家";
i18n['agencies']['country'] = "国家";
i18n['agencies']['currency'] = "";
i18n['agencies']['filter-all-cities-name'] = "所有城市";
i18n['agencies']['filter-all-cities-name-prepositional'] = "所有城市";
i18n['agencies']['filter-all-cities-preposition'] = "";
i18n['agencies']['filters-conjunction'] = "与";
i18n['agencies']['filters-delimiter'] = "、";
i18n['agencies']['filters-reset'] = "重设筛选条件";
i18n['agencies']['not-found'] = "未 找到符合 这些条件的公司。请重新设置筛选条件后 再次尝试查找。";
i18n['agencies']['only-offices-found'] = "";
i18n['agencies']['only-partners-found'] = "一些没有现行资质认证的代理商符合您选定的条件。";
i18n['agencies']['other-offices'] = "";
i18n['agencies']['other-partners'] = "没有现行资质认证的代理商";
i18n['agencies']['region-choose'] = "选择国家";
i18n['agencies']['search'] = "搜索";
i18n['agencies']['service'] = "服务";
i18n['agencies']['show-text'] = "";
i18n['agencies']['specify'] = "确定搜索条件";
i18n['agencies']['text'] = "本页面中提供Yandex中国区代理商信息。请使用下拉菜单，挑选所需城市与服务。";
i18n['agencies']['title'] = "认证代理商";
i18n['dashboard'] = {};
i18n['dashboard']['cat.1239063375'] = "";
i18n['dashboard']['cat.1412163005'] = "";
i18n['dashboard']['cat.1473509328'] = "";
i18n['dashboard']['cat.1582506554'] = "";
i18n['dashboard']['cat.1644710081'] = "";
i18n['dashboard']['cat.200304283'] = "";
i18n['dashboard']['cat.2107020788'] = "";
i18n['dashboard']['cat.2222683737'] = "";
i18n['dashboard']['cat.2408536966'] = "";
i18n['dashboard']['cat.2455984605'] = "";
i18n['dashboard']['cat.2473087795'] = "";
i18n['dashboard']['cat.2587886448'] = "";
i18n['dashboard']['cat.3119845291'] = "";
i18n['dashboard']['cat.3315302486'] = "";
i18n['dashboard']['cat.3566538395'] = "";
i18n['dashboard']['cat.3737414780'] = "";
i18n['dashboard']['cat.3989916053'] = "";
i18n['dashboard']['cat.4170831985'] = "";
i18n['dashboard']['cat.4194169969'] = "";
i18n['dashboard']['cat.491274388'] = "";
i18n['dashboard']['cat.518209040'] = "";
i18n['dashboard']['cat.570002290'] = "";
i18n['dashboard']['cat.676268400'] = "";
i18n['dashboard']['cat.80967844'] = "";
i18n['dashboard']['cat.auto'] = "";
i18n['dashboard']['cat.consulting'] = "";
i18n['dashboard']['cat.finance'] = "";
i18n['dashboard']['cat.realty'] = "";
i18n['dashboard']['cat.retail'] = "";
i18n['dashboard']['comparison.add'] = "";
i18n['dashboard']['comparison.delete'] = "";
i18n['dashboard']['error.modal'] = "";
i18n['dashboard']['error.widget'] = "";
i18n['dashboard']['platform.desktop'] = "";
i18n['dashboard']['platform.mobile'] = "";
i18n['dashboard']['region.1'] = "";
i18n['dashboard']['region.10174'] = "";
i18n['dashboard']['region.102444'] = "";
i18n['dashboard']['region.17'] = "";
i18n['dashboard']['region.17,-2'] = "";
i18n['dashboard']['region.225'] = "";
i18n['dashboard']['region.26'] = "";
i18n['dashboard']['region.3'] = "";
i18n['dashboard']['region.3,-213'] = "";
i18n['dashboard']['region.40'] = "";
i18n['dashboard']['region.52'] = "";
i18n['dashboard']['region.59'] = "";
i18n['dashboard']['region.73'] = "";
i18n['dashboard']['title.add'] = "";
i18n['dashboard']['title.remove'] = "";
i18n['dashboard']['type.interest'] = "";
i18n['dashboard']['type.network'] = "";
i18n['dashboard']['type.search'] = "";
i18n['dashboard']['widget.type.interest'] = "";
i18n['offices'] = {};
i18n['offices']['readmore'] = "了解更多";
i18n['news'] = {};
i18n['news']['400_CII'] = "";
i18n['news']['400_LII'] = "";
i18n['news']['400_SII'] = "";
i18n['news']['400_VFL'] = "";
i18n['news']['401_NAU'] = "";
i18n['news']['403_CCI'] = "";
i18n['news']['403_PRO'] = "";
i18n['news']['403_UAC'] = "";
i18n['news']['403_UBN'] = "";
i18n['news']['403_UNM'] = "";
i18n['news']['413_ETL'] = "";
i18n['news']['500_ISE'] = "";
i18n['news']['breadcrumb'] = "主要新闻";
i18n['news']['comments'] = "";
i18n['news']['comments.add_error'] = "";
i18n['news']['comments.banned'] = "";
i18n['news']['comments.bound-phone'] = "";
i18n['news']['comments.bound-phone-text'] = "";
i18n['news']['comments.complain_error'] = "";
i18n['news']['comments.count'] = "";
i18n['news']['comments.enter-url'] = "";
i18n['news']['comments.get_error'] = "";
i18n['news']['comments.hint'] = "";
i18n['news']['comments.load-captcha_error'] = "";
i18n['news']['comments.non-authorized'] = "";
i18n['news']['comments.removed'] = "";
i18n['news']['comments.send'] = "";
i18n['news']['comments.unavailable'] = "";
i18n['news']['comments.your-reply'] = "";
i18n['news']['comments.your-word'] = "";
i18n['news']['complaint'] = "";
i18n['news']['complaint.question'] = "";
i18n['news']['default_error'] = "";
i18n['news']['edu.nav.list'] = "";
i18n['news']['edu.nav.next'] = "";
i18n['news']['filters.clear'] = "清除筛选";
i18n['news']['for_all_time'] = "全时间";
i18n['news']['index.archive'] = "新闻";
i18n['news']['index.title'] = "广告新闻";
i18n['news']['related.title'] = "更多相关新闻：";
i18n['news']['reply'] = "";
i18n['news']['tags'] = "所有主题";
i18n['edu'] = {};
i18n['edu']['answer'] = "提交";
i18n['edu']['city'] = "城市";
i18n['edu']['company'] = "公司";
i18n['edu']['contact'] = "联系";
i18n['edu']['country'] = "国家";
i18n['edu']['events'] = "活动";
i18n['edu']['expert.readyToComeInYourCity'] = "可以前往您的所在城市";
i18n['edu']['expert.readyToTrips'] = "准备出差";
i18n['edu']['leave.feedback'] = "留下反馈";
i18n['edu']['lesson-content'] = "在本节课您可了解到";
i18n['edu']['lessons.list'] = "所有培训课";
i18n['edu']['months'] = "月";
i18n['edu']['next.lesson'] = "下一课";
i18n['edu']['online'] = "在线";
i18n['edu']['prev.lesson'] = "前一课";
i18n['edu']['reviews'] = "反馈";
i18n['edu']['specialization'] = "专业";
i18n['edu']['starts.at'] = "起始时间";
i18n['edu']['themes'] = "所有主题";
i18n['edu']['user.certificate'] = "用户证书";
i18n['edu']['workFormat'] = "工作形式";
i18n['solutions'] = {};
i18n['solutions']['analytics'] = "";
i18n['solutions']['cases'] = "案例分析";
i18n['solutions']['changes'] = "";
i18n['solutions']['city'] = "城市";
i18n['solutions']['clear'] = "清除";
i18n['solutions']['companySize'] = "公司规模";
i18n['solutions']['error'] = "";
i18n['solutions']['industries'] = "选择行业";
i18n['solutions']['periods'] = "";
i18n['solutions']['practicums'] = "";
i18n['solutions']['products'] = "产品种类";
i18n['solutions']['read.more'] = "了解更多";
i18n['solutions']['registration.year'] = "成立日期";
i18n['solutions']['site'] = "网址";
i18n['solutions']['stories'] = "成功案例";
i18n['solutions']['tasks'] = "目标";
i18n['solutions']['yandex.year'] = "使用Direct系统";
i18n['pages'] = {};
i18n['pages']['contact.description'] = "销售办事处与广告代理商";
i18n['pages']['contact.keywords'] = "销售办事处、客服、代理商";
i18n['pages']['contact.title'] = "联系方式 —— Yandex.Advertising";
i18n['pages']['index.description'] = "";
i18n['pages']['index.keywords'] = "";
i18n['pages']['index.title'] = "在Yandex投放广告 —— Yandex.Advertising";
i18n['pages']['news.title'] = "新闻 — Yandex.Advertising";
i18n['pages']['order.title'] = "投放广告";
i18n['pages']['partners-news.title'] = "";
i18n['pages']['partners.title'] = "广告代理商";
i18n['pages']['requirements.title'] = "广告资料要求";
i18n['pages']['subscription.partners.title'] = "";
i18n['pages']['subscription.public.title'] = "";
i18n['agency'] = {};
i18n['agency']['add-office'] = "";
i18n['agency']['address'] = "地址";
i18n['agency']['agencies-with-certificates'] = function(params) { return "若想要查看认证代理商，请点击<a href=\"" + params["agenciesPageUrl"] + "\">这里</a>。" };
i18n['agency']['agency-experience'] = "代理商经验";
i18n['agency']['allagencies'] = "所有代理商";
i18n['agency']['back-to-edit'] = "";
i18n['agency']['bidder'] = "Yandex PPC 广告竞价管理合作伙伴";
i18n['agency']['budget'] = "";
i18n['agency']['budget-placeholder'] = "";
i18n['agency']['cancel-editing'] = "";
i18n['agency']['card-link'] = "更多";
i18n['agency']['case'] = "案例分析";
i18n['agency']['cert-by-yandex'] = "";
i18n['agency']['certificate_plate'] = "";
i18n['agency']['certificate_title'] = "";
i18n['agency']['certificates'] = "认证";
i18n['agency']['certified-yandex-agency'] = "Yandex<br>认证代理商";
i18n['agency']['city'] = "城市";
i18n['agency']['contact-info'] = "联系方式";
i18n['agency']['description-placeholder'] = "";
i18n['agency']['edit'] = "";
i18n['agency']['editing-mode'] = "";
i18n['agency']['email'] = "电子邮箱";
i18n['agency']['feedback'] = "联系代理商";
i18n['agency']['form.button'] = "发送";
i18n['agency']['form.email'] = "您的电子邮箱地址";
i18n['agency']['form.message'] = "消息正文";
i18n['agency']['form.name'] = "您的姓名";
i18n['agency']['full-description-counter'] = "";
i18n['agency']['material-error'] = "";
i18n['agency']['material-placeholder'] = "";
i18n['agency']['materials'] = "代理商资料";
i18n['agency']['modal.title'] = "联系代理商";
i18n['agency']['name-placeholder'] = "";
i18n['agency']['next'] = "下一个";
i18n['agency']['non-active-agency'] = "本 代理商暂没有现行的资质认证。";
i18n['agency']['on-moderation'] = "";
i18n['agency']['phone'] = "电话号码";
i18n['agency']['prev'] = "前一个";
i18n['agency']['preview-description-counter'] = "";
i18n['agency']['qualified-yandex-partner'] = "Yandex<br>认证伙伴";
i18n['agency']['yndx-partner'] = "Yandex Certified Partner";
i18n['agency']['yng-partner'] = "Yango Certified Partner";
i18n['agency']['readmore'] = "了解更多";
i18n['agency']['remove'] = "";
i18n['agency']['send-to-moderation'] = "";
i18n['agency']['sending-fail'] = "";
i18n['agency']['show-phone'] = "显示电话号码";
i18n['agency']['show-preview'] = "";
i18n['agency']['site'] = "网址";
i18n['agency']['specialization'] = "专业化";
i18n['agency']['type.appmetrica'] = "Mobile ads";
i18n['agency']['type.bidder'] = "Yandex Direct PPC 广告竞价管理合作伙伴";
i18n['agency']['type.dialogs'] = "";
i18n['agency']['type.direct'] = "Yandex Direct";
i18n['agency']['type.geomapadv'] = "Yandex Business";
i18n['agency']['type.geonaviadv'] = "Yandex Navigator";
i18n['agency']['type.market'] = "Yandex Market";
i18n['agency']['type.media-adv'] = "";
i18n['agency']['type.metrika'] = "Yandex Metrica";
i18n['agency']['type.promopages'] = "";
i18n['agency']['type.toloka'] = "";
i18n['agency']['type.zen'] = "";
i18n['agency']['type.campaigns'] = "Ads Campaigns";
i18n['agency']['type.ads-space'] = "Ads Space";
i18n['agency']['type.ridetech'] = "Ridetech";
i18n['agency']['type.in-app-ads'] = "In-App Ads";
i18n['agency']['yandex-partner'] = "Yandex伙伴";
i18n['search'] = {};
i18n['search']['0'] = "";
i18n['search']['1'] = "";
i18n['search']['2'] = "";
i18n['search']['3'] = "";
i18n['search']['4'] = "";
i18n['search']['5'] = "";
i18n['search']['6'] = "";
i18n['search']['7'] = "";
i18n['search']['8'] = "";
i18n['search']['9'] = "";
i18n['search']['all.pages'] = "";
i18n['search']['find'] = "";
i18n['search']['found'] = "";
i18n['search']['materials'] = "";
i18n['search']['not.found'] = "";
i18n['search']['partners'] = "";
i18n['search']['search'] = "";
i18n['search']['site.search'] = "";
i18n['search']['switch.left'] = "";
i18n['search']['switch.right'] = "";
i18n['header'] = {};
i18n['header']['service.adv'] = "Yandex中国区公司官方网站";
i18n['header']['service.blog'] = "博客";
i18n['header']['service.company'] = "公司";
i18n['header']['service.edu'] = "教育";
i18n['header']['service.events'] = "活动";
i18n['header']['service.science'] = "调研";
i18n['header']['service.tech'] = "开发者";
i18n['header']['service.vacancies'] = "空缺";
i18n['products'] = {};
i18n['products']['link'] = "所有报价";
i18n['products']['more'] = "显示更多";
i18n['products']['more-detailed'] = "";
i18n['products']['more.button'] = "了解更多";
i18n['products']['order.button'] = "联系我们";
i18n['products']['targetings'] = "定向类型：";
i18n['products']['terms'] = "完整产品条款";
i18n['months'] = {};
i18n['months']['g1'] = "";
i18n['months']['g10'] = "";
i18n['months']['g11'] = "";
i18n['months']['g12'] = "";
i18n['months']['g2'] = "";
i18n['months']['g3'] = "";
i18n['months']['g4'] = "";
i18n['months']['g5'] = "";
i18n['months']['g6'] = "";
i18n['months']['g7'] = "";
i18n['months']['g8'] = "";
i18n['months']['g9'] = "";
i18n['months']['n1'] = "";
i18n['months']['n10'] = "";
i18n['months']['n11'] = "";
i18n['months']['n12'] = "";
i18n['months']['n2'] = "";
i18n['months']['n3'] = "";
i18n['months']['n4'] = "";
i18n['months']['n5'] = "";
i18n['months']['n6'] = "";
i18n['months']['n7'] = "";
i18n['months']['n8'] = "";
i18n['months']['n9'] = "";
i18n['file-upload'] = {};
i18n['file-upload']['files-limit-error'] = function(params) { return "您可上传不超过 " + params["count"] + " " + dynamic.plural_adv({"count": params["count"], "one": "个文件", "some": "个文件", "many": "个文件", "none": "个文件"}) };
i18n['file-upload']['limit-hint'] = function(params) { return "最多" + params["count"] + dynamic.plural_adv({"count": params["count"], "one": "个", "some": "个", "many": "个", "none": "个"}) + dynamic.toggle({"condition": params["总"], "true": "", "false": ""}) + "大小不超过" + params["大小不超过"] + " MB的文件" };
i18n['file-upload']['size-limit-error'] = function(params) { return "上传文件的大小超过 " + params["size"] + " MB" };
i18n['file-upload']['upload-text'] = "上传";
i18n['sections'] = {};
i18n['sections']['analytics'] = "数据分析";
i18n['sections']['contact'] = "联系方式";
i18n['sections']['distribution'] = "分布";
i18n['sections']['edu.events'] = "建议访问";
i18n['sections']['edu.experts'] = "培训伙伴";
i18n['sections']['education'] = "教育";
i18n['sections']['index'] = "首页";
i18n['sections']['monetization'] = "";
i18n['sections']['news'] = "Yandex广告新闻";
i18n['sections']['order'] = "投放广告";
i18n['sections']['partners'] = "广告代理商";
i18n['sections']['publishers'] = "";
i18n['sections']['requirements'] = "广告资料要求";
i18n['sections']['subscription.partners'] = "";
i18n['sections']['subscription.public'] = "";
i18n['sections']['subscription.publishers'] = "";
i18n['sections']['subscription.subs'] = "";
i18n['menu'] = {};
i18n['menu']['agency'] = "本地广告代理商";
i18n['menu']['backward'] = "返回";
i18n['menu']['backward-section'] = "";
i18n['menu']['menu'] = "菜单";
i18n['menu']['offices'] = "销售办事处";
i18n['menu']['order'] = "联系我们";
i18n['menu']['support'] = "客服";
i18n['support'] = {};
i18n['support']['feedback.form'] = "发送消息";
i18n['support']['feedback.link'] = "申请表";
i18n['materials'] = {};
i18n['materials']['error'] = "";
i18n['partners'] = {};
i18n['partners']['button.back'] = "";
i18n['partners']['button.next'] = "";
i18n['partners']['button.send'] = "";
i18n['partners']['followTheNews'] = "";
i18n['partners']['form.direct'] = "";
i18n['partners']['form.directAndMarket'] = "";
i18n['partners']['form.disk.button'] = "";
i18n['partners']['form.disk.modal.1'] = "";
i18n['partners']['form.disk.modal.2'] = "";
i18n['partners']['form.disk.pseudolink'] = "";
i18n['partners']['form.emptyValue'] = "";
i18n['partners']['form.error.email'] = "";
i18n['partners']['form.error.required'] = "";
i18n['partners']['form.market'] = "";
i18n['partners']['form.tip'] = "";
i18n['partners']['form.ty.contract'] = "";
i18n['partners']['form.ty.login'] = "";
i18n['partners']['form.ty.title'] = "";
i18n['partners']['goal.chooseGoal'] = "";
i18n['partners']['goal.chooseGoal.text'] = "";
i18n['partners']['goal.contract'] = "";
i18n['partners']['goal.contract.text'] = "";
i18n['partners']['goal.login'] = "";
i18n['partners']['goal.login.direct.text'] = "";
i18n['partners']['goal.login.directAndMarket.text'] = "";
i18n['partners']['goal.login.market.text'] = "";
i18n['partners']['menu.becomePartner'] = "";
i18n['partners']['products'] = "";
i18n['partners']['step1'] = "";
i18n['partners']['step2'] = "";
i18n['forms'] = {};
i18n['forms']['400_SMF'] = "";
i18n['forms']['400_SNA'] = "";
i18n['forms']['400_SNS'] = "";
i18n['forms']['403_CCI'] = "";
i18n['forms']['403_ICT'] = "出错了，请稍后再试。";
i18n['forms']['503_MNS'] = "信息发送失败。请再试一次。";
i18n['forms']['captcha'] = "请输入图片上的代码：";
i18n['forms']['captcha.change'] = "换码";
i18n['forms']['emptyValue'] = "";
i18n['forms']['error'] = "出错了，请稍后再试。";
i18n['forms']['error.server'] = "出错了，请再试一次。";
i18n['forms']['form'] = "表格";
i18n['forms']['label.comment'] = "发表评论";
i18n['forms']['label.email'] = "您的电子邮箱地址";
i18n['forms']['label.login'] = "Yandex账户名";
i18n['forms']['label.name'] = "您的姓名";
i18n['forms']['label.phone'] = "电话号码";
i18n['forms']['label.region'] = "地区";
i18n['forms']['label.site'] = "网址";
i18n['forms']['subscribed.multi.text'] = "";
i18n['forms']['subscribed.multi.title'] = "感谢！";
i18n['forms']['subscribed.single.text'] = "";
i18n['forms']['subscribed.single.title'] = "感谢！";
i18n['forms']['subscription.button'] = "";
i18n['forms']['subscription.button.register'] = "";
i18n['forms']['success.agency.text'] = "您的申请发送成功！";
i18n['forms']['success.agency.title'] = "感谢！";
i18n['forms']['success.def.text'] = "请别发送重复消息。我们的专家将一定会给您回复。";
i18n['forms']['success.def.title'] = "您的消息发送成功";
i18n['filters'] = {};
i18n['filters']['clear'] = "清除过滤器";
i18n['order'] = {};
i18n['order']['agency'] = "通过广告代理商";
i18n['order']['chooseAgency'] = "选择广告代理商";
i18n['order']['city'] = "城市";
i18n['order']['country'] = "国家";
i18n['order']['createAd'] = "创建广告";
i18n['order']['form'] = "在Yandex客户经理帮助下创建";
i18n['order']['personally'] = "自主创建";
i18n['order']['pleaseSpecifyYourLocation'] = "请选择您所在的城市（若您所在的城市在列表中没有，请选择离您最近的城市）：";
i18n['order']['sendForm'] = "发送";
i18n['order']['title'] = "投放广告";
i18n['common'] = {};
i18n['common']['addUser'] = "切换用户名";
i18n['common']['amp-breadcrumb'] = "新闻";
i18n['common']['and'] = "与";
i18n['common']['comdi.not-supported'] = "";
i18n['common']['conditions'] = "条款";
i18n['common']['days'] = "";
i18n['common']['facebook'] = "Facebook";
i18n['common']['habrahabr'] = "Habrahabr";
i18n['common']['hours'] = "";
i18n['common']['instagram'] = "Instagram";
i18n['common']['linkedin'] = "LinkedIn";
i18n['common']['loading-error'] = "错误加载";
i18n['common']['login'] = "登陆";
i18n['common']['logout'] = "登出";
i18n['common']['media.cases'] = "案例分析";
i18n['common']['media.courses'] = "教学课程";
i18n['common']['media.stories'] = "成功案例";
i18n['common']['minutes'] = "";
i18n['common']['more.button.error'] = "出错了，请稍后再试。";
i18n['common']['more.button.text'] = "显示更多";
i18n['common']['news-is-not-available'] = "消息部分暂时无法使用。请稍后再试。";
i18n['common']['no'] = "否";
i18n['common']['oldbrowser.close'] = "关闭";
i18n['common']['oldbrowser.download'] = "更新浏览器";
i18n['common']['oldbrowser.text'] = "无法保证该服务可用性";
i18n['common']['online.edu'] = "在线教育";
i18n['common']['project.name'] = "广告技术";
i18n['common']['rss'] = "RSS";
i18n['common']['search.all_pages'] = "所有页面";
i18n['common']['seconds'] = "";
i18n['common']['show-full'] = "阅读全文";
i18n['common']['swipe.slideInfo'] = "";
i18n['common']['twitter'] = "Twitter";
i18n['common']['vkontakte'] = "Vkontakte";
i18n['common']['yes'] = "是";
i18n['common']['youtube'] = "YouTube";
i18n['common']['сancel'] = "取消";

export default i18n;